import { apiClient } from '../../api/client';

export type CertificateRow = {
  id: number; number: string; type: string; customer: string;
  balance_display: string; valid_until_display: string; source_at_display: string; title_display: string;
};
export type CertificateJournal = { words: Record<string, string>; rows: CertificateRow[] };
export type CertificateHistory = {
  number: string; balance_display: string;
  rows: { id: number; at_display: string; operation: string; amount_display: string; check_display: string }[];
};
export type CertificateChoice = { id: number; number: string; label: string; balance_display: string };
export const getCertificateMenuWord = async () => (await apiClient.get<{ label: string }>('/certificates/words')).data;
export const getCertificateJournal = async (filial: number) =>
  (await apiClient.get<CertificateJournal>('/certificates', { params: { filial_id: filial || undefined } })).data;
export const getCertificateHistory = async (id: number, filial: number) =>
  (await apiClient.get<CertificateHistory>(`/certificates/${id}/history`, { params: { filial_id: filial || undefined } })).data;
export const getCertificateChoices = async (booking: number) =>
  (await apiClient.get<{ rows: CertificateChoice[] }>(`/zapis/${booking}/certificate-options`)).data;
export type BonusChoice = { enabled: boolean; can_spend: boolean; suggested_display: string; label: string; balance_display: string };
export const getBonusChoices = async (booking: number) =>
  (await apiClient.get<BonusChoice>(`/zapis/${booking}/bonus-options`)).data;
